/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Lifetime_TitleInputs */

const en_us2_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Since your first workout`)
};

const pt_br2_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde o primeiro treino`)
};

const es_419_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde tu primer entrenamiento`)
};

const pt_pt2_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desde o primeiro treino`)
};

const fr_fr2_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depuis ta première séance`)
};

const de_de2_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit deinem ersten Training`)
};

const it_it2_progress_extra_lifetime_title = /** @type {(inputs: Progress_Extra_Lifetime_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dal primo allenamento`)
};

/**
* | output |
* | --- |
* | "Since your first workout" |
*
* @param {Progress_Extra_Lifetime_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_lifetime_title = /** @type {((inputs?: Progress_Extra_Lifetime_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Lifetime_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_lifetime_title(inputs)
	if (locale === "es-419") return es_419_progress_extra_lifetime_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_lifetime_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_lifetime_title(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_lifetime_title(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_lifetime_title(inputs)
	return en_us2_progress_extra_lifetime_title(inputs)
});
export { progress_extra_lifetime_title as "progress-extra.lifetime_title" }